import { render } from "./MenuStorageBar.vue?vue&type=template&id=073caad5&scoped=true"
import script from "./MenuStorageBar.vue?vue&type=script&lang=js"
export * from "./MenuStorageBar.vue?vue&type=script&lang=js"

import "./MenuStorageBar.vue?vue&type=style&index=0&id=073caad5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073caad5"]])

export default __exports__